import api from "../axios";

export interface GetAttachmentEnquiryParams {
    cityid: string;
    fromdate: string;
    todate: string;
    type: string;
    status: string;
    limit?: number;
    skip?: number;
}

export const addAttachmentEnquiry = (data: any) => {
    return api.post('/booking/addAttachmentEnquiry', data);
}

export const getAttachmentEnquiry = (
    cityid: string,
    fromdate: string,
    todate: string,
    type: string,
    status: string
) => {
    return api.get(
        `/booking/getAttachmentEnquiry?cityid=${cityid}&fromdate=${fromdate}&todate=${todate}&type=${type}&status=${status}`
    );
};